export default "__VITE_ASSET__VfhFNkeSXSWZqtbgs1Jx7A__"